import _ from 'lodash';
import { USER_ROLES } from './constants';
import dialogLoader from './dialogLoader';
import _masterSlideLoader from './masterSlideLoader';
import {
  getSafetyDiaryDetailPageName,
  isForemanRoleId,
} from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import {
  NotificationConstants,
  NotificationLevel,
} from './notificationConstants';
import SafetyDiariesConstants from './safetyDiariesConstants';
import _slideLoader from './slideLoader';
import * as dialog from '../components/NotificationDialog';
import { CraneUseService } from '../services/CraneUses';
import { GatePassageService } from '../services/GatePassages';
import { MachineryUseService } from '../services/MachineryUses';
import SessionsService from '../services/Sessions';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import { WorkScheduleService } from '../services/Works';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { FieldService } from '../services/Fields';
import fetchMg from '../utilities/fetchManager';
import { util } from '../canvas/common/util';
import moment from 'moment';
import { getNextDay } from '../canvas/common/works';
import { changeFieldWriteStorage } from '../utilities/fieldUtil';
import { NotificationService } from '../services/Notification';

const ERROR_MESSAGE =
  'すでに対応が完了しているか、または対象のデータが削除済みのため表示することができません。';
const ERROR_TITLE = '無効な通知です';
const showDialog = (title, content, callback) => {
  dialogLoader.show(dialog.Confirmation, {
    state: {
      title,
      content,
    },

    callback: {
      close: callback,
    },
  });
};

const handleChangeField = async fieldId => {
  if (LocalStorageService.getRoleId() === USER_ROLES.partner.id) {
    return SessionsService.updatePartnerByField(fieldId).then(resp => {
      if (!resp.result) {
        console.error(
          '選択現場の更新に失敗しました',
          'notificationUtility.js',
          'handleChangeField',
          'SessionsService.updatePartnerByField',
          resp
        );
        return;
      }
      return SessionsService.updatefield(fieldId).then(async resp => {
        if (!resp.result) {
          // console.error('選択現場の更新に失敗しました');
          console.error(
            '選択現場の更新に失敗しました',
            'notificationUtility.js',
            'handleChangeField',
            'SessionsService.updatefield',
            resp
          );
          return;
        }

        return FieldService.info(fieldId)
          .then(response => {
            if (!response.result) {
              console.error(
                'notificationUtility.js',
                'handleChangeField',
                'FieldService.info !response.result',
                response
              );
              return;
            }
            return changeFieldWriteStorage(response.data.entities.field);
          })
          .catch(error => {
            console.error(
              'notificationUtility.js',
              'handleChangeField',
              'FieldService.info catch',
              error
            );
          });
      });
    });
  } else {
    return SessionsService.updatefield(fieldId).then(async resp => {
      if (!resp.result) {
        // console.error('選択現場の更新に失敗しました');
        console.error(
          '選択現場の更新に失敗しました',
          'notificationUtility.js',
          'handleChangeField',
          'SessionsService.updatefield',
          resp
        );
        return;
      }

      return FieldService.info(fieldId)
        .then(response => {
          if (!response.result) {
            console.error(
              'notificationUtility.js',
              'handleChangeField',
              'FieldService.info !response.result',
              response
            );
            return;
          }
          return changeFieldWriteStorage(response.data.entities.field);
        })
        .catch(error => {
          console.error(
            'notificationUtility.js',
            'handleChangeField',
            'FieldService.info catch',
            error
          );
        });
    });
  }
};

/**
 * @description 通知リンク有無チェック
 * @param {object} notification 通知情報
 */
const hasLink = notification => {
  const notificationType = _.find(
    NotificationConstants,
    notify => notify.messageTypeId === notification.message_type_id
  );
  return notificationType.link;
};

/**
 * @description 通知強ダイアログボタン名取得
 * @param {object} notification 通知情報
 */
const hasBlueButtonTitle = notification => {
  const notificationType = _.find(
    NotificationConstants,
    notify => notify.messageTypeId === notification.message_type_id
  );
  return notificationType.blueButtonTitle;
};

/**
 * @description 通知アイコン取得
 * @param {object} notification 通知情報
 */
const hasIcon = notification => {
  const notificationType = _.find(
    NotificationConstants,
    notify => notify.messageTypeId === notification.message_type_id
  );
  return notificationType.icon;
};

/**
 * @description 通知強チェック
 * @param {object} notification 通知情報
 */
const isStrongNotification = notification => {
  const notificationType = _.find(
    NotificationConstants,
    notify => notify.messageTypeId === notification.message_type_id
  );
  if (!notificationType) {
    return false;
  }
  return NotificationLevel.strong === notification.level;
};

// 通知に必要なデータが存在してるかチェック
const paramsExist = (params, required) => {
  let result = true;
  _.forEach(required, param => {
    if (_.isUndefined(_.get(params, param)) || _.isNull(_.get(params, param))) {
      result = false;
    }
  });
  return result;
};

/**
 * @description グループ、タイプ取得
 * @param {number} messageTypeId メッセージタイプID
 */
const notificationType = messageTypeId => {
  if (
    [
      NotificationConstants.conferenceWorkPlansNotEnteredNotification
        .messageTypeId, // 56 #作業予定実績未入力通知(強)
    ].includes(messageTypeId)
  ) {
    return {
      group: 'WORKS_STRONG',
      type: 'NOT_ENTERED',
    };
  }
  if (
    [
      NotificationConstants.conferenceWorkPlansNotEnteredAndNotCopyNotification
        .messageTypeId, // 71 #作業予定実績未入力通知(実績未コピー)
    ].includes(messageTypeId)
  ) {
    return {
      group: 'WORKS_STRONG',
      type: 'NOT_COPY',
    };
  }
  if (
    [
      NotificationConstants.safetyDiariesPointedOutFromManager.messageTypeId, // 1 #現場監督からの巡回記録の指摘の通知(強)
      NotificationConstants.safetyDiariesPointedOutFromForeman.messageTypeId, // 3 #職長からの巡回記録の指摘の通知(強)
      NotificationConstants.safetyDiariesRecoveryRejectedFromManager
        .messageTypeId, // 11 #現場監督からの巡回記録の是正否認の通知（強）
      NotificationConstants.safetyDiariesRecoveryRejectedFromForeman
        .messageTypeId, // 12 #職長からの巡回記録の是正否認の通知（強）
      NotificationConstants.safetyDiariesPointedOutFromBranch.messageTypeId, // 15 #支店管理者からの巡回記録の指摘の通知(強)
      NotificationConstants.safetyDiariesRecoveryRejectedFromBranch
        .messageTypeId, // 19 #支店管理者からの巡回記録の是正否認の通知（強）
      NotificationConstants.safetyDiariesPointedOutFromPartner.messageTypeId, // 21 #番頭からの巡回記録の指摘の通知(強)
      NotificationConstants.safetyDiariesRecoveryRejectedFromPartner
        .messageTypeId, // 24 #番頭からの巡回記録の是正否認の通知（強）
      NotificationConstants.safetyDiariesPointedOutFromPrime.messageTypeId, // 31 #本社管理者からの巡回記録の指摘の通知(強)
      NotificationConstants.safetyDiariesRecoveryRejectedFromPrime
        .messageTypeId, // 35 #本社管理者からの巡回記録の是正否認の通知（強）
    ].includes(messageTypeId)
  ) {
    return {
      group: 'SAFETY_DIARY_STRONG',
    };
  }
  if (
    [
      NotificationConstants.safetyDiariesRecoveryFromManager.messageTypeId, // 7 #現場監督からの巡回記録の是正報告の通知
      NotificationConstants.safetyDiariesRecoveryFromForeman.messageTypeId, // 8 #職長からの巡回記録の是正報告の通知
      NotificationConstants.safetyDiariesRecoveryFromBranch.messageTypeId, // 17 #支店管理者からの巡回記録の是正報告の通知
      NotificationConstants.safetyDiariesRecoveryFromPrime.messageTypeId, // 33 #本社管理者からの巡回記録の是正報告の通知
      NotificationConstants.safetyDiariesRecoveryFromPartner.messageTypeId, // 22 #番頭からの巡回記録の是正報告の通知
      NotificationConstants.safetyDiariesRecoveryApprovedFromManager
        .messageTypeId, // 9 #現場監督からの巡回記録の是正承認の通知
      NotificationConstants.safetyDiariesRecoveryApprovedFromForeman
        .messageTypeId, // 10 #職長からの巡回記録の是正承認の通知
      NotificationConstants.safetyDiariesRecoveryApprovedFromBranch
        .messageTypeId, // 18 #支店管理者からの巡回記録の是正承認の通知
      NotificationConstants.safetyDiariesRecoveryApprovedFromPrime
        .messageTypeId, // 34 #本社管理者からの巡回記録の是正承認の通知
      NotificationConstants.safetyDiariesRecoveryApprovedFromPartner
        .messageTypeId, // 23 #番頭からの巡回記録の是正承認の通知
      NotificationConstants.safetyDiariesPointedOutDropped.messageTypeId, // 60 # 巡回記録指摘の取り下げ
      NotificationConstants.safetyDiariesInformFromManager.messageTypeId, // 2 #現場監督からの巡回記録の周知の通知
      NotificationConstants.safetyDiariesInformFromForeman.messageTypeId, // 4 #職長からの巡回記録の周知の通知
      NotificationConstants.safetyDiariesInformFromBranch.messageTypeId, // 16 #支店管理者からの巡回記録の周知の通知
      NotificationConstants.safetyDiariesInformFromPrime.messageTypeId, // 32 #本社管理者からの巡回記録の周知の通知
      NotificationConstants.safetyDiariesInformFromPartner.messageTypeId, // 25 #番頭からの巡回記録の周知の通知
      NotificationConstants.safetyDiariesWorkCommunicationFromManager
        .messageTypeId, // 13 #現場監督からの巡回記録の当日作業連絡の通知
      NotificationConstants.safetyDiariesWorkCommunicationFromForeman
        .messageTypeId, // 14 #職長からの巡回記録の当日作業連絡の通知
      NotificationConstants.safetyDiariesWorkCommunicationFromBranch
        .messageTypeId, // 20 #支店管理者からの巡回記録の当日作業連絡の通知
      NotificationConstants.safetyDiariesWorkCommunicationFromPartner
        .messageTypeId, // 26 #番頭からの巡回記録の当日作業連絡の通知
      NotificationConstants.safetyDiariesWorkCommunicationFromPrime
        .messageTypeId, // 36 #本社管理者からの巡回記録の当日作業連絡の通知
      // NotificationConstants.contactDetail.messageTypeId, // 101 #現場監督からの巡回記録の是正報告の通知
    ].includes(messageTypeId)
  ) {
    return {
      group: 'SAFETY_DIARY',
    };
  }
  if (
    [
      NotificationConstants.fieldTreeLinked.messageTypeId, // 46 #施工体系図紐付き
      NotificationConstants.fieldTreeUnlinked.messageTypeId, // 47 #施工体系図紐付き解除
      NotificationConstants.fieldTreePartnerCompanyDeleted.messageTypeId, // 51 #施工体系図の協力会社削除
      NotificationConstants.fieldTreePartnerCompanyWorkCompleted.messageTypeId, // 52 #施工体制図の協力会社作業完了
      NotificationConstants.fieldTreePartnerCompanyWorkResumed.messageTypeId, // 53 #施工体制図の協力会社作業完了
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_TREE',
      type: 'NONE',
    };
  }
  if (
    [
      NotificationConstants.fieldTreeApproved.messageTypeId, // 49 #施工体系図承認
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_TREE',
      type: 'APPROVED',
    };
  }
  if (
    [
      NotificationConstants.fieldTreeRequest.messageTypeId, // 48 #施工体制図申請(強)
      NotificationConstants.fieldTreeRejected.messageTypeId, // 50 #施工体制図否認(強)
      NotificationConstants.fieldTreeApprovalRequestReminder.messageTypeId, // 72 #施工体系図申請催促(強)
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_TREE_STRONG',
    };
  }
  if (
    [
      NotificationConstants.successToRegisterFieldTreeForCcusNotification
        .messageTypeId, // 310 #CCUSへの施工体制連携成功
      NotificationConstants
        .partiallyFailedToRegisterFieldTreeForCcusNotification.messageTypeId, // 312 #CCUSへの施工体制連携一部異常
      NotificationConstants.successToRegisterFieldTreeWorkerForCcusNotification
        .messageTypeId, // 313 #CCUSへの施工体系作業員連携成功
      NotificationConstants
        .partiallyFailedToRegisterFieldTreeWorkerForCcusNotificationToManager
        .messageTypeId, // 315 #CCUSへの施工体系作業員一部異常（現場監督向け）
      NotificationConstants
        .partiallyFailedToRegisterFieldTreeWorkerForCcusNotificationToPartner
        .messageTypeId, // 316 #CCUSへの施工体系作業員一部異常（協力会社管理者向け）
    ].includes(messageTypeId)
  ) {
    return {
      group: 'CCUS_FIELD_TREE',
    };
  }
  if (
    [
      NotificationConstants.failedToRegisterFieldTreeForCcusNotification
        .messageTypeId, // 311 #CCUSへの施工体制連携異常
      NotificationConstants.failedToRegisterFieldTreeWorkerForCcusNotification
        .messageTypeId, // 314 #CCUSへの施工体系作業員異常
    ].includes(messageTypeId)
  ) {
    return {
      group: 'CCUS_FIELD_TREE_STRONG',
    };
  }
  if (
    [
      NotificationConstants.masterNewFieldCreated.messageTypeId, // 61 #新規現場作成
      NotificationConstants.masterNewJVCreated.messageTypeId, // 73 #新規JV作成
      NotificationConstants.masterFieldCreatedRequest.messageTypeId, // 900 #新規現場申請
      NotificationConstants.masterNewFieldApproved.messageTypeId, // 41 #新規現場申請承認
      NotificationConstants.masterNewFieldRejected.messageTypeId, // 42 #新規現場申請否認
      NotificationConstants.fieldUpdatedFromBranch.messageTypeId, // 5 #支店管理者からの現場マスタ(現場情報)の変更の通知
      NotificationConstants.fieldUpdatedFromManager.messageTypeId, // 6 #現場監督からの現場マスタ(現場情報)の変更の通知
      NotificationConstants.fieldUpdatedFromPrime.messageTypeId, // 30 #本社管理者からの現場マスタ(現場情報)の変更の通知
      NotificationConstants.linkedFieldToIchiPlus.messageTypeId, // 75 #位置プラス連携完了
      NotificationConstants.successToRegisterSiteForCcusNotification
        .messageTypeId, // 301 #入退場：CCUSへの現場契約情報登録の成功通知
      NotificationConstants.failToRegisterSiteForCcusOnLambdaNotification
        .messageTypeId, // 302 #入退場：CCUSへの現場契約情報登録の失敗通知（lambda)
      NotificationConstants.failToRegisterSiteForCcusOnApiNotification
        .messageTypeId, // 303 #入退場：CCUSへの現場契約情報登録の失敗通知（API)
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_INFO',
    };
  }
  if (
    // param1, 該当日, 現場ID
    [
      // param1 = works/:id
      NotificationConstants.conferenceWorkPlansCreatedNotification // 54 #作業予定登録通知
        .messageTypeId,
      NotificationConstants.conferenceWorkPlansUpdatedNotification // 59 #作業予定更新通知
        .messageTypeId,
      NotificationConstants.conferenceWorkResultsCreatedNotification // 62 #作業実績登録通知
        .messageTypeId,
      NotificationConstants.conferenceWorkResultsUpdatedNotification // 67 #作業実績更新通知
        .messageTypeId,
      NotificationConstants.conferenceWorkPlansApprovedReleaseNotification // 55 #作業予定承認の解除通知
        .messageTypeId,
      NotificationConstants.conferenceWorkResultsApprovedReleaseNotification // 66 #作業実績承認の解除通知
        .messageTypeId,
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_FUNCTION',
      type: 'WORKS',
    };
  }
  if (
    [
      // param1 = gate_passages/:id
      NotificationConstants.conferenceGatePlansCreatedNotification // 63 #ゲート予定登録通知
        .messageTypeId,
      // param1 = gate_passages/:id
      NotificationConstants.conferenceGatePlansUpdatedNotification // 68 #ゲート予定更新通知
        .messageTypeId,
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_FUNCTION',
      type: 'GATE_PASSAGES',
    };
  }
  if (
    [
      // param1 = crane_uses/:id
      NotificationConstants.conferenceCranePlansCreatedNotification // 64 #揚重機予定登録通知
        .messageTypeId,
      // param1 = crane_uses/:id
      NotificationConstants.conferenceCranePlansUpdatedNotification // 69 #揚重機予定更新通知
        .messageTypeId,
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_FUNCTION',
      type: 'CRANE_USES',
    };
  }
  if (
    [
      // param1 = machinery_uses/:id
      NotificationConstants.conferenceEquipmentPlansCreatedNotification // 65 #機材予定登録通知
        .messageTypeId,
      // param1 = machinery_uses/:id
      NotificationConstants.conferenceEquipmentPlansUpdatedNotification // 70 #機材予定更新通知
        .messageTypeId,
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_FUNCTION',
      type: 'MACHINERY_USES',
    };
  }
  if (
    [
      NotificationConstants.failToRegisterSiteForCcusAtInOutResultNotification
        .messageTypeId, // 304 #入退場：CCUSへの入退場実績の登録に失敗したことの通知
      NotificationConstants.workHistoryApprovalRequestNotification
        .messageTypeId, // 305 #入退場：就業履歴の承認要求通知
      NotificationConstants.workHistoryApprovalNotification.messageTypeId, // 306 #就業履歴の承認通知(入退場実績)
      NotificationConstants.workHistoryDisApprovalNotification.messageTypeId, // 307 #就業履歴の承認解除通知(入退場実績)
    ].includes(messageTypeId)
  ) {
    return {
      group: 'FIELD_FUNCTION',
      type: 'IN_OUT',
    };
  }

  return { group: null, type: null };
};

/**
 * @description 画面遷移処理_通知強以外
 * @param {number} messageTypeId メッセージタイプID
 * @param {object} params 画面遷移用パラメータ
 * @param {number} vw viewID
 */
const executeActionNotificationOtherStrong = async (
  messageTypeId,
  params,
  vw
) => {
  const notification = _.find(
    NotificationConstants,
    notification => notification.messageTypeId === messageTypeId
  );

  if (notification.link) {
    const { group, type } = notificationType(notification.messageTypeId);
    // 機能一覧関連
    if (group === 'FIELD_FUNCTION') {
      if (!paramsExist(params, ['field_id', 'target_date'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      const navigate = async (messageTypeId, notification, params, vw) => {
        await handleChangeField(params.field_id);
        sessionStorage.setItem('date_from', params.target_date);
        sessionStorage.setItem('date_to', params.target_date);
        navigateSlide(notification, params, vw);
      };

      params.id = params.param1;

      if (type === 'WORKS') {
        return WorkScheduleService.show(params.field_id, params.id).then(
          response => {
            if (
              !response ||
              (_.has(response.data, 'result') && response.data.result === false)
            ) {
              notification.isSlide = false;
              showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
                dialogLoader.close();
                return (window.location.href =
                  '/conference/0/0/0/Dashboard:1/Dashboard:0');
              });
            } else {
              return navigate(
                notification.messageTypeId,
                notification,
                params,
                vw
              );
            }
          }
        );
      }

      if (type === 'GATE_PASSAGES') {
        return GatePassageService.show(params.field_id, params.id)
          .then(() => {
            navigate(messageTypeId, notification, params, vw);
          })
          .catch(() => {
            console.log('GatePassageService.show', '404 Error');

            notification.isSlide = false;
            showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
              dialogLoader.close();
              return (window.location.href =
                '/conference/0/0/0/Dashboard:1/Dashboard:0');
            });
            return;
          });
      }

      if (type === 'CRANE_USES') {
        return CraneUseService.show(params.field_id, params.id)
          .then(() => {
            return navigate(messageTypeId, notification, params, vw);
          })
          .catch(() => {
            console.log('CraneUseService.show', '404 Error');

            notification.isSlide = false;
            showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
              dialogLoader.close();
              return (window.location.href =
                '/conference/0/0/0/Dashboard:1/Dashboard:0');
            });
            return;
          });
      }

      if (type === 'MACHINERY_USES') {
        return MachineryUseService.show(params.field_id, params.id)
          .then(() => {
            return navigate(messageTypeId, notification, params, vw);
          })
          .catch(() => {
            console.log('MachineryUseService.show', '404 Error');

            notification.isSlide = false;
            showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
              dialogLoader.close();
              return (window.location.href =
                '/conference/0/0/0/Dashboard:1/Dashboard:0');
            });
            return;
          });
      }

      if (type === 'IN_OUT') {
        sessionStorage.setItem('date_from', params.target_date);
        sessionStorage.setItem('date_to', params.target_date);
        await handleChangeField(params.field_id);
        return (window.location.href = `/gatekeeper/0/0/0/${
          notification.linkTo
        }:1/0:0`);
      }

      return navigate(notification.messageTypeId, notification, params, vw);
    }

    // 現場情報関連
    // param1 = fields/:id
    if (group === 'FIELD_INFO') {
      if (!_.isNumber(params.field_id)) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      const nextDay = await getNextDay(params.field_id);
      if (nextDay === null) {
        showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
          dialogLoader.close();
        });
        return;
      }
      const workNextDay = moment(
        util.dataFormat(nextDay, 'YYYY/MM/DD'),
        'YYYY/MM/DD'
      ).format('YYYY/MM/DD');

      const data = await fetchMg
        .GetAjax(`/api/private/fields/${params.field_id}`)
        .catch(() => ({ result: false }));
      // console.log('data', data);
      sessionStorage.setItem('date_from', workNextDay);
      sessionStorage.setItem('date_to', workNextDay);

      sessionStorage.setItem('use_gk_flg', data.data.entities.field.use_gk_flg);
      sessionStorage.setItem(
        'use_roan_flg',
        data.data.entities.field.use_roan_flg
      );
      sessionStorage.setItem(
        'use_tracker_flg',
        data.data.entities.field.use_tracker_flg
      );

      // 現場IDを変更する
      // 新規現場申請の場合は変更しない
      if (![
        NotificationConstants.masterFieldCreatedRequest.messageTypeId,
      ].includes(notification.messageTypeId)) {
        await handleChangeField(params.field_id);
      }
      // マスターメニュー移動の場合
      if (notification.isMasterSlide) {
        params.id = params.field_id;
        //現場情報更新（共通API：他システムとの連携用）
        // 現場詳細に移動する場合はbeforePageNameが必要なため追加
        if (notification.linkTo === 'FieldsDetail') {
          params.pageReferer = notification.beforePageName;
        } else if (notification.linkTo === 'IchiPlusLinkageSettingDetail') {
          // BLDE_V2-42140の問題があるため、location.hrefで実装。BLDE_V2-42140の対応をする時にこちらも修正検討対象に含めること
          return (window.location.href = `/conference/IchiPlusLinkageSettingDetail:${
            params.field_id
          }/0/0/0/0`);
        }
        return navigateMasterSlide(notification, params, vw);
      }
      return navigateSlide(notification, params, vw);
    }

    // param1 = companies/:id
    if (
      [
        NotificationConstants.masterCompanyInformationUpdated.messageTypeId, // 43 #会社情報の更新(元請本社)
      ].includes(notification.messageTypeId)
    ) {
      params.id = params.param1;
    }

    if (
      [
        NotificationConstants.masterPartnerCompanyInformationUpdated
          .messageTypeId, // 45 #会社情報の更新(協力会社情報)
      ].includes(notification.messageTypeId)
    ) {
      if (!paramsExist(params, ['param_json'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      const companyId = SessionStorageService.getCompanyId();
      if (
        companyId === String(params.param1) &&
        LocalStorageService.getRoleId() === USER_ROLES.partner.id
      ) {
        // 協力会社管理者でログイン時に選択した元請会社に関する通知の場合
        return _masterSlideLoader.show('CompanyPreview', {
          state: { id: companyId },
        });
      } else {
        if (_.isString(params.param_json)) {
          let paramBuffer = params.param_json;
          paramBuffer = paramBuffer.replace(
            'partner_company_id',
            '"partner_company_id"'
          );
          paramBuffer = paramBuffer.replace(
            'company_branch_id',
            '"company_branch_id"'
          );
          const parseObj = JSON.parse(paramBuffer);
          params.id = `${parseObj.partner_company_id}.${
            parseObj.company_branch_id
          }`;
        } else {
          params.id = `${params.param_json.partner_company_id}.${
            params.param_json.company_branch_id
          }`;
        }
        return navigateMasterSlide(notification, params, vw);
      }
    }

    // param1 = field_tree/:id
    // 施工体系図遷移しない
    if (group === 'FIELD_TREE') {
      if (
        messageTypeId === NotificationConstants.fieldTreeLinked.messageTypeId && // 46 #施工体系図紐付き
        !isForemanRoleId()
      ) {
        return await moveFieldTree(notification, params, vw);
      }
      if (type === 'NONE') {
        return;
      }

      if (!paramsExist(params, ['field_id', 'param1'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      await moveFieldTree(notification, params, vw);
      return;
    }

    // 施工体系図
    if (group === 'CCUS_FIELD_TREE') {
      if (!paramsExist(params, ['field_id'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      await moveFieldTree(notification, params, vw);
      return;
    }

    // 巡回記録
    // param1 = safety_diaries/:id
    if (group === 'SAFETY_DIARY') {
      await moveSafetyDiary(notification, params);
      return;
    }

    if (
      [
        NotificationConstants.contactDetail.messageTypeId, // 101 #現場監督からの巡回記録の是正報告の通知
      ].includes(notification.messageTypeId)
    ) {
      params.id = params.param1;
      params.dataId = params.param1;

      // 101 #お問い合わせ
      location.href = `/conference/${notification.linkTo}:${
        params.param1
      }/0/0/0/0:0`;
      return;
    }

    navigateSlide(notification, params, vw);
  }
};

/**
 * @description 画面遷移処理_通知強
 * @param {number} messageTypeId メッセージタイプID
 * @param {object} params 画面遷移用パラメータ
 */
const executeActionNotificationStrong = async (messageTypeId, params) => {
  const notification = _.find(
    NotificationConstants,
    notification => notification.messageTypeId === messageTypeId
  );

  // console.log(
  //   'notificationUtility.js',
  //   'executeActionNotificationStrong',
  //   notification
  // );

  if (notification.link) {
    const { group, type } = notificationType(notification.messageTypeId);

    // param1 = field_trees/:id
    // fields/:idも必要
    if (group === 'FIELD_TREE_STRONG') {
      if (!paramsExist(params, ['field_id', 'param1'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      params.id = params.param1;
      await moveFieldTree(notification, params);
      return;
    }

    // 施工体系図
    if (group === 'CCUS_FIELD_TREE_STRONG') {
      if (!paramsExist(params, ['field_id'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      await moveFieldTree(notification, params);
      return;
    }

    // param1 = works/:id
    if (group === 'WORKS_STRONG') {
      if (!paramsExist(params, ['field_id', 'target_date', 'param1'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }
      params.id = params.param1;

      return WorkScheduleService.show(params.field_id, params.id).then(
        async response => {
          if (
            !response ||
            (_.has(response.data, 'result') && response.data.result === false)
          ) {
            showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
              dialogLoader.close();
              return (window.location.href =
                '/conference/0/0/0/Dashboard:1/Dashboard:0');
            });
            return;
          } else {
            await handleChangeField(params.field_id);
            sessionStorage.setItem('date_from', params.target_date);
            sessionStorage.setItem('date_to', params.target_date);

            if (type === 'NOT_ENTERED') {
              params.id = params.param1;
              params.dataId = params.param1;
              let environments = location.host;
              let WorkResulturl = `${environments}/conference/0:1/0/0/WorkResult:1/Dashboard:0`;
              SessionStorageService.setItem('WorkResulturl', WorkResulturl);
              navigateSlide(notification, params, 1);
              return;
            }
            if (type === 'NOT_COPY') {
              let environments = location.host;
              let WorkResulturl = `${environments}/conference/0:1/0/0/WorkResult:1/Dashboard:0`;
              SessionStorageService.setItem('WorkResulturl', WorkResulturl);
              return WorkScheduleService.schedulesReflectOnHistories(
                params.field_id,
                params.target_date,
                params.param1
              )
                .then(response => {
                  if (response.result) {
                    params.id = response.data.entities.works[0].id;
                    params.dataId = response.data.entities.works[0].id;
                    navigateSlide(notification, params, 1);
                  } else {
                    return;
                  }
                })
                .catch(error => {
                  // #BLDE_V2-20246 職長ー職種の整合性がおかしい時は400
                  if (error.status === 400) {
                    if (!error.data.result) {
                      showDialog(
                        ERROR_TITLE,
                        response.data.message,
                        async () => {
                          dialogLoader.close();
                        }
                      );
                      return;
                    }
                  } else {
                    showDialog(
                      ERROR_TITLE,
                      messageUtility.getMessage('E-001-315'),
                      async () => {
                        dialogLoader.close();
                      }
                    );
                  }
                });
            }
          }
        }
      );
    }

    if (group === 'SAFETY_DIARY_STRONG') {
      await moveSafetyDiary(notification, params);
      return;
    }

    if (type === 'IN_OUT') {
      if (!paramsExist(params, ['field_id', 'target_date'])) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      sessionStorage.setItem('date_from', params.target_date);
      sessionStorage.setItem('date_to', params.target_date);
      await handleChangeField(params.field_id);
      return (window.location.href = `/gatekeeper/0/0/0/${
        notification.linkTo
      }:1/0:0`);
    }

    // 現場情報関連
    if (group === 'FIELD_INFO') {
      if (!_.isNumber(params.field_id)) {
        return console.error(
          `通知先の読み込みに失敗しました。 Notification ID: ${
            params.notificationId
          }`
        );
      }

      // 現場IDを変更する
      await handleChangeField(params.field_id);
      // マスターメニュー移動の場合
      if (notification.isMasterSlide) {
        params.id = params.field_id;
        //現場情報更新（共通API：他システムとの連携用）
        // 現場詳細に移動する場合はbeforePageNameが必要なため追加
        if (notification.linkTo === 'FieldsDetail') {
          params.pageReferer = notification.beforePageName;
        }
        return navigateMasterSlide(notification, params);
      } else {
        // 機能一覧内移動の場合
        sessionStorage.setItem('field_id', params.field_id);
      }
      return navigateSlide(notification, params);
    }
  }
};

const navigateSlide = (notification, params, vw) => {
  vw = vw ? vw : 1; // 強通知はView1に表示する

  if (!notification.isSlide) {
    if (notification.isMasterSlide) {
      navigateMasterSlide(notification, params, vw);
      return;
    }

    return (location.href = `/conference/0/0/0/${notification.linkTo}:1/0:0`);
  }
  _masterSlideLoader.close();
  return _slideLoader.show(
    notification.linkTo,
    {
      state: {
        ...params,
        onClose: () => {
          _slideLoader.close(vw);
        },
      },
    },
    vw
  );
};

const navigateMasterSlide = (notification, params, vw) => {
  vw = vw ? vw : 1; // 強通知はView1に表示する

  return _masterSlideLoader.show(
    notification.linkTo,
    {
      state: {
        ...params,
        onClose: () => {
          _slideLoader.close(vw);
        },
      },
    },
    vw
  );
};

const moveFieldTree = async (notification, params, vw = undefined) => {
  if (SessionStorageService.getFieldId() !== String(params.field_id)) {
    // 現場が異なる場合は現場変更してURL切り替えてリロード
    // 現状の画面遷移の仕組み上はリロードしないと正常に動作しない
    await handleChangeField(params.field_id);
    window.history.pushState(
      null,
      null,
      '/conference/FieldTreePage:1/0/0/Dashboard:1/Dashboard:0'
    );
    window.location.reload();
  } else {
    navigateMasterSlide(notification, params, vw);
  }
};

const moveSafetyDiary = async (notification, params) => {
  if (!paramsExist(params, ['param1', 'field_id'])) {
    console.error(
      `通知先の読み込みに失敗しました。 Notification ID: ${
        params.notificationId
      }`
    );
  }

  const param = {
    date_type: SafetyDiariesConstants.dataType.entriesDate,
  };
  const safetyDiaryId = params.param1;
  SafetyDiaryService.getDiary(params.field_id, safetyDiaryId, param)
    .then(async response => {
      const data = response.data.entities.safety_diary;
      const linkTo = getSafetyDiaryDetailPageName(data);

      if (SessionStorageService.getFieldId() !== String(params.field_id)) {
        // 現場が異なる場合は現場変更してURL切り替えてリロード
        // 現状の画面遷移の仕組み上はリロードしないと正常に動作しない
        await handleChangeField(params.field_id);
        // 閉じるとDashboardになるようにURLを指定
        window.history.pushState(
          null,
          null,
          `/conference/0:1/${linkTo}:${safetyDiaryId}/0/Dashboard:1/0:0`
        );
        window.location.reload();
      } else {
        params.id = params.param1;
        params.dataId = params.param1;
        params.params = param;

        _masterSlideLoader.close();
        _slideLoader.show(
          linkTo,
          {
            state: {
              ...params,
            },
          },
          1
        );
      }
    })
    .catch(() => {
      console.log('SafetyDiaryService.getDiary', '404 Error');

      notification.isSlide = false;
      showDialog(ERROR_TITLE, ERROR_MESSAGE, async () => {
        dialogLoader.close();
        return (window.location.href =
          '/conference/0/0/0/Dashboard:1/Dashboard:0');
      });
    });
};

const read = async notification => {
  // 通知強で未読の場合のみAPIを呼ぶ。通知弱の場合は何もしない。
  if (
    notification.read_flag === false &&
    notification.level === NotificationLevel.strong
  ) {
    await NotificationService.read(notification.id).then(response => {
      if (!response.result) {
        console.log('通知既読機能が失敗しました。');
        return;
      }
    });
  }
};

const NotificationUtility = {
  hasLink,
  hasBlueButtonTitle,
  hasIcon,
  isStrongNotification,
  executeActionNotificationOtherStrong,
  executeActionNotificationStrong,
  read,
  handleChangeField,
};

export default NotificationUtility;



// WEBPACK FOOTER //
// ./src/utilities/notificationUtility.js